export default "__VITE_ASSET__mhgUl728__"